import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { ContractService } from '../../service/contract/contract.service';
import { Contract } from '../../class/contract';
import { Message, ConfirmationService, LazyLoadEvent, CalendarModule, SelectItem, ToggleButtonModule } from 'primeng/primeng';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { HasPermissionService } from '../../service/has-permission/has-permission.service';
import { Candidate } from '../../class/candidate';
import { CandidateService } from '../../service/candidate/candidate.service';
import { config } from '../../../../../environments/config';
import { UploadFilesService } from '../../service/upload-files/upload-files.service';
import { NotificationsService } from '../../../../theme/services/notifications/notifications.service';
import { DocumentProfileSurveyService } from '../../service/document-profile-survey/document-profile-survey.service';
import { formatDate } from '../../../../theme/functions/formatDate.function';
import { calendarES } from '../../../../theme/functions/calendarES';
@Component({
  selector: 'app-expired-documents',
  templateUrl: './expired-documents.component.html',
  styleUrls: ['./expired-documents.component.scss']
})
export class ExpiredDocumentsComponent implements OnInit {
    
    public totalRecords: number = 0;
    public page: number;
    public per_page: number;
    public sort: string;
    public query: string;

    public apiUrl = config.API_ROOT;
    public modExportDialog: boolean;
    public es: any;
    public msgs: Message[] = [];
    public filters: any[];
    public contracts: Contract[];
    public form: FormGroup;
    public form1: FormGroup;
    public company_id_filter: AbstractControl;
    public company_export: AbstractControl;
    public date_start: AbstractControl;
    public date_end: AbstractControl;

  constructor(public contractService: ContractService,
              public documentProfileSurveyService: DocumentProfileSurveyService,
              public fb: FormBuilder,) { 

      this.form = fb.group({
        'company_id_filter': [''],
      });
      this.company_id_filter = this.form.controls['company_id_filter'];

      this.form1 = fb.group({
        'date_start': ['',[Validators.required]],
        'date_end': ['',[Validators.required]],
        'company_export': [''],
      });

      this.date_start = this.form1.controls['date_start'];
      this.date_end = this.form1.controls['date_end'];
      this.company_export = this.form1.controls['company_export'];

      this.modExportDialog = false;
      this.es = calendarES();
  }

  ngOnInit() {
    this.page = 1;
    this.per_page = 10;

  }
  public loadContractsLazy(event: LazyLoadEvent) {
    this.page = (event.first / this.per_page) + 1;
    if (event.sortOrder === -1) {
        this.sort =  '-' + event.sortField;
    } else {
        this.sort =  event.sortField;
    }

    if (event.globalFilter) {
        this.query = event.globalFilter;
    } else {
        this.query = undefined;
    }

    this.sort = '-id';
    this.getDocumentsExpired(event.globalFilter);
    
  }
  public filter (values) {
    this.page = 1;
    // this.first = 0;

    this.filters = [];
    
    if (values.company_id_filter) {
      this.filters.push({'key': 'company_id', 'value': values.company_id_filter.id});
    }
    
  // if (this.start_contract_filter.value && this.end_contract_filter.value) {
  //     let d = new Date(this.start_contract_filter.value);
  //     d.setHours(0);
  //     d.setMinutes(0);
  //     d.setSeconds(0);
  //     d.setMilliseconds(0);

  //     const start_contract_filter = this.formatDate(d);

  //     d = new Date(this.end_contract_filter.value);
  //     d.setHours(23);
  //     d.setMinutes(59);
  //     d.setSeconds(59);
  //     d.setMilliseconds(59);
  //     const end_contract_filter = this.formatDate(d);

  //     if (start_contract_filter) {
  //         this.filters.push({'key': 'start_contract-min', 'value': start_contract_filter});
  //     }

  //     if (end_contract_filter) {
  //         this.filters.push({'key': 'start_contract-max', 'value': end_contract_filter});
  //     }

  // }

  // this.getContracts();
  this.getDocumentsExpired();
}
  public getDocumentsExpired(query?: string) {
    this.documentProfileSurveyService.getDocumentProfileSurveyExpired(this.page, this.per_page, this.sort, query, this.filters).toPromise().then(
        response => {
            this.contracts = response.json().data;
            if (response.json().meta.total > response.json().meta.total_filtered) {
                this.totalRecords = response.json().meta.total_filtered;
            } else {
                this.totalRecords = response.json().meta.total;
            }
        },
        error => {
            this.msgs = [];
            this.msgs.push( { severity: 'error', summary: 'error' } );
        }
    );

  }

  public showExportDialog() {
    this.modExportDialog = true;
  }

  public exportReportExcel(values) {
    let d = new Date(values.date_start);
    d.setHours(0);
    d.setMinutes(0);
    d.setSeconds(0);
    d.setMilliseconds(0);
    const date_start = formatDate(d);

    d = new Date(values.date_end);
    d.setHours(23);
    d.setMinutes(59);
    d.setSeconds(59);
    d.setMilliseconds(59);
    const date_end = formatDate(d);

    var url = this.apiUrl + '/document-profile-surveis/documents-expired/excel?'+
        'token=' + localStorage.getItem('token') +
        '&_page=1&';

    if (values.company_export)
      url = url + 'company_id=' + values.company_export.id + '&';
    
    if (date_start) {
      url = url + 'date-min=' + date_start + '&';
    }

    if (date_end) {
      url = url + 'date-max=' + date_end;
    }

    window.open(url, '_blank');
  }
  public cancelExport() {
    this.modExportDialog = false;
  }

}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/expired-documents/expired-documents.component.ts